module.exports = __webpack_public_path__ + "18046547363916c7bdfe4556f7cd6989.svg";